import { render, staticRenderFns } from "./setTimeFrequency.vue?vue&type=template&id=3458ad36"
import script from "./setTimeFrequency.vue?vue&type=script&lang=js"
export * from "./setTimeFrequency.vue?vue&type=script&lang=js"
import style0 from "./setTimeFrequency.vue?vue&type=style&index=0&id=3458ad36&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports